import { ISettingsReport } from '../models/settingsReport/settingsReport';
import { AxiosService, OnlineService } from '.';
import { ApiEndpoints } from '@/config/index';
import { LoggerService } from '@/utils';
import { OnlineStatusEnums } from '@/enums/OnlineStatusEnums';
import { AuthStore } from '../store/store.auth';

class SettingsReportProvider {

    // tslint:disable-next-line: no-empty
    constructor() {}

    public async FetchSettingsReports(): Promise<ISettingsReport[]> {
        const result: Promise<ISettingsReport[]> = new Promise<ISettingsReport[]>(async (resolve, reject) => {
            if (OnlineService.GetOnlineStatus === OnlineStatusEnums.ONLINE
                && AuthStore.GetIsLoggedIn === true) {
                await AxiosService.get(ApiEndpoints.reports, null)
                    .then((response) => {
                        resolve(response.data as ISettingsReport[]);
                    });
            } else {
                LoggerService.LogWarn(`Cant connect to api server, returning empty settings report list`);
                // reject({ error: 'offline', messege: 'Cant connect to api server' });
                resolve([]);
            }
        });
        return result;
    }
}

export default SettingsReportProvider;
